import { profileRuleset } from './profile.ruleset';

export const ruleset = profileRuleset;
